export default __webpack_public_path__ + "static/media/wsm.33484511.png";